import axios from './axios'
import { CreateLessonDto, LessonDto, UpdateLessonDto } from './types'

export const getLessonsByDate = (date: string) => {
  return axios.get<LessonDto[]>('/lessons', { params: { date } })
}

export const getLessonsByCustomer = (customerId: string) => {
  return axios.get<LessonDto[]>('/lessons', { params: { customerId } })
}

export const getLesson = (id: string) => {
  return axios.get<LessonDto>(`/lessons/${id}`)
}

export const createLesson = (data: CreateLessonDto) => {
  return axios.post<LessonDto>('/lessons', data)
}

export const updateLesson = (id: string, data: UpdateLessonDto) => {
  return axios.put<LessonDto>(`/lessons/${id}`, data)
}

export const deleteLesson = (id: string) => {
  return axios.delete<void>(`/lessons/${id}`)
}
